import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFirebaseAuthToken } from "../../helpers/firebase_helper";
const API_BASE = process.env.REACT_APP_API_BASE_URL;

export const paymentMethod = createAsyncThunk(
  "onboarding/paymentMethod",
  async (request, { rejectWithValue }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/payment/payment-method`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(request),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData);
      }

      const res = await response.json();
      return res;
    } catch (error) {
      return rejectWithValue(error.toString());
    }
  }
);

export const deletePaymentMethod = createAsyncThunk(
  "onboarding/deletePaymentMethod",
  async (request, { rejectWithValue }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/payment/payment-method`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(request),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData);
      }

      const res = await response.json();
      return res;
    } catch (error) {
      return rejectWithValue(error.toString());
    }
  }
);
